/*
 * Get condition rollups
 */
import { clientFetch } from '../clientFetch';

export const getConditionRollups = (params) => {
  return clientFetch('/search/condition-rollups', { params });
};
